
import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'vg-header',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-200 shadow-sm z-50 relative">
            <!-- Sidebar Toggle Button -->
            <button class="p-2 -ml-2 rounded-lg text-gray-600 hover:bg-gray-100" (click)="toggleSidebar.emit()">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
            </button>

            <!-- Title -->
            <div class="text-lg font-semibold text-gray-800 hidden md:block">
                Voucher Generator
            </div>

            <!-- Right Side Actions -->
            <div class="flex items-center gap-4">
                <span class="text-sm text-gray-600 font-medium hidden sm:inline">{{ userName }}</span>

                <div class="h-8 w-px bg-gray-200 mx-2"></div>

                <button (click)="signOut()" class="flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-red-500 transition">
                    <span>Sign Out</span>
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg>
                </button>
            </div>
        </div>
    `
})
export class VgHeaderComponent implements OnInit {
    @Output() toggleSidebar = new EventEmitter<void>();
    userName: string = 'User';

    constructor(
        private _authService: AuthService,
        private _router: Router
    ) {}

    ngOnInit(): void {
        const user = this._authService.getCurrentUser();
        if (user) {
            this.userName = user.name || user.username || 'User';
        }
    }

    signOut(): void {
        this._authService.signOut().subscribe(() => {
            this._router.navigate(['/sign-in']);
        });
    }
}
